import { View } from 'native-base'

const Hr = () => (
  <View borderBottomColor="gray.300" borderBottomWidth={0.5} h="10px" />
)

export default Hr
